import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { OMNIBAR_CONSTANTS } from './omnibar-constants';
/**
 * Provides facilities for interacting with the internal DOM of `OmnibarComponent`.
 */
var OmnibarAdapter = /** @class */ (function (_super) {
    __extends(OmnibarAdapter, _super);
    function OmnibarAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._rootElement = getShadowElement(component, OMNIBAR_CONSTANTS.selectors.ROOT);
        _this._titleElement = getShadowElement(component, OMNIBAR_CONSTANTS.selectors.TITLE);
        _this._bottomElement = getShadowElement(component, OMNIBAR_CONSTANTS.selectors.BOTTOM);
        _this._bottomSlotElement = getShadowElement(component, OMNIBAR_CONSTANTS.selectors.BOTTOM_SLOT);
        _this._centerSlotElement = getShadowElement(component, OMNIBAR_CONSTANTS.selectors.CENTER_SLOT);
        _this._centerSectionElement = getShadowElement(component, OMNIBAR_CONSTANTS.selectors.CENTER_SECTION);
        _this._logoElement = getShadowElement(component, OMNIBAR_CONSTANTS.selectors.LOGO);
        return _this;
    }
    /**
     * Sets the title text value.
     * @param {string} value The title text.
     */
    OmnibarAdapter.prototype.setTitleText = function (value) {
        this._titleElement.textContent = value;
    };
    OmnibarAdapter.prototype.setDense = function (value) {
        value ? this._rootElement.classList.add(OMNIBAR_CONSTANTS.classes.DENSE) : this._rootElement.classList.remove(OMNIBAR_CONSTANTS.classes.DENSE);
    };
    OmnibarAdapter.prototype.setRaised = function (value) {
        value ? this._rootElement.classList.add(OMNIBAR_CONSTANTS.classes.RAISED) : this._rootElement.classList.remove(OMNIBAR_CONSTANTS.classes.RAISED);
    };
    OmnibarAdapter.prototype.setProminent = function (value) {
        value ? this._rootElement.classList.add(OMNIBAR_CONSTANTS.classes.PROMINENT) : this._rootElement.classList.remove(OMNIBAR_CONSTANTS.classes.PROMINENT);
    };
    OmnibarAdapter.prototype.setFixed = function (value) {
        value ? this._rootElement.classList.add(OMNIBAR_CONSTANTS.classes.FIXED) : this._rootElement.classList.remove(OMNIBAR_CONSTANTS.classes.FIXED);
    };
    OmnibarAdapter.prototype.addBottomClass = function (name) {
        this._bottomElement.classList.add(name);
    };
    OmnibarAdapter.prototype.removeBottomClass = function (name) {
        this._bottomElement.classList.remove(name);
    };
    OmnibarAdapter.prototype.addBottomSlotListener = function (listener) {
        this._bottomSlotElement.addEventListener('slotchange', listener);
    };
    OmnibarAdapter.prototype.addCenterSlotListener = function (listener) {
        this._centerSlotElement.addEventListener('slotchange', listener);
    };
    OmnibarAdapter.prototype.setCenterSlotVisibility = function () {
        if (this._centerSlotElement.assignedNodes().length) {
            this._centerSectionElement.style.removeProperty('display');
            this._rootElement.classList.remove(OMNIBAR_CONSTANTS.classes.NO_CENTER);
        }
        else {
            this._centerSectionElement.style.display = 'none';
            this._rootElement.classList.add(OMNIBAR_CONSTANTS.classes.NO_CENTER);
        }
    };
    OmnibarAdapter.prototype.setLogoVisibility = function (visible) {
        if (visible) {
            this._logoElement.style.removeProperty('display');
        }
        else {
            this._logoElement.style.display = 'none';
        }
    };
    return OmnibarAdapter;
}(BaseAdapter));
export { OmnibarAdapter };
